import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Lock } from "lucide-react";
import { Logo } from "@/components/Logo";

const links = [
  { to: "/", label: "Home" },
  { to: "/advisory", label: "Expert Advisory" },
  { to: "/mediation", label: "Mediation" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location]);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10 py-3" : "bg-transparent py-6"}`}>
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between">
        <Logo size="sm" />
        <div className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-sm tracking-wide link-underline transition-colors ${location.pathname === l.to ? "text-white" : "text-zinc-400 hover:text-white"}`}>
              {l.label}
            </Link>
          ))}
          <Link to="/login" data-testid="nav-client-login"
            className="flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/20 text-sm text-zinc-200 hover:border-white/50 hover:text-white transition-all">
            <Lock size={14} strokeWidth={1.5} /> Client Portal
          </Link>
        </div>
        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>
      {open && (
        <div className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 mt-3 px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <Link key={l.to} to={l.to} className="text-zinc-300 text-base py-1" data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}>{l.label}</Link>
          ))}
          <Link to="/login" className="mt-2 flex items-center gap-2 px-5 py-3 rounded-full border border-white/20 text-zinc-200 w-fit" data-testid="mobile-nav-login">
            <Lock size={14} /> Client Portal
          </Link>
        </div>
      )}
    </header>
  );
};
